import {getLocal, random, setLocal} from "ubs-framework/v2/common/function";
import {MULTILEVEL} from "../../common/constant";

const initialState = {
    isAuthenticated: false,
    socketId: '',
    token: '',
    _id: '',
    uac: null,
    user_id: '',
    firstName: '',
    lastName: '',
    fullName: '',
    email: '',
    phone:'',
    S3_BASE_URL: '',
    orgId: '',
    owner:'',
    planAccess: {},
    fileSizeLimit: 3,
    pdfFileLimit: 25,
    error: null,
    addMember: '',
    isAdmin: false,
    files: {},
    workSpaces: [],
    tabId: random.id(16),
    filterData: {},
    version: 0,
    release: {},
    videoUrl:{},
    isPreBoarding: false,
    preBoardingStatus: null,
    preBoardingStep: null,
    preBoardingId: null,
    jobView: getLocal('u_pv') ? getLocal('u_pv') : 'grid',
    candidateView: getLocal('u_cv') ? getLocal('u_cv') : 'list',
    jobWiseCandidateView: getLocal('u_jw') ? getLocal('u_jw') : 'list',
    recruitWiseView: getLocal('u_rw') ? getLocal('u_rw') : 'list',
    stagWiseView: getLocal('u_sw') ? getLocal('u_sw') : 'list',
    disqualifyView: getLocal('u_dv') ? getLocal('u_dv') : 'list',
    sourceWiseView: getLocal('u_swv') ? getLocal('u_swv') : 'list',
    allJobView: getLocal('u_aj') ? getLocal('u_aj') : 'list',
    jobInterviewView: getLocal('u_jiv') ? getLocal('u_jiv') : 'list',
    archiveView: getLocal('u_av') ? getLocal('u_av') : 'list',
    candidateArchiveView: getLocal('u_cav') ? getLocal('u_cav') : 'list',
    candidateActiveView: getLocal('u_acv') ? getLocal('u_acv') : 'list',
    timeToFillView: getLocal('u_ttf') ? getLocal('u_ttf') : 'list',
    employeeTurnoverRateView: getLocal('u_etr') ? getLocal('u_etr') : 'list',
    offerAcceptanceRateView: getLocal('u_oar') ? getLocal('u_oar') : 'list',
    fillRateView: getLocal('u_fr') ? getLocal('u_fr') : 'list',
    interviewToOfferRatioView: getLocal('u_itor') ? getLocal('u_itor') : 'list',
    recruitmentPipelineStatusView: getLocal('u_rps') ? getLocal('u_rps') : 'list',
    rejectedAndHoldCandidatesView: getLocal('u_rahc') ? getLocal('u_rahc') : 'list',
    openingVsApplicationVsOnboardingView: getLocal('u_ovavo') ? getLocal('u_ovavo') : 'list',
    offerReleasedVsOfferAcceptanceView: getLocal('u_orvoa') ? getLocal('u_orvoa') : 'list',
    diversityHiringView: getLocal('u_dh') ? getLocal('u_dh') : 'list',
    jobwiseVsStatusWiseVsTagWiseView: getLocal('u_jwswtw') ? getLocal('u_jwswtw') : 'list',
    workforceForecastVsActualView: getLocal('u_wfva') ? getLocal('u_wfva') : 'list',
    budgetForecastVsActualSpendView: getLocal('u_bfvas') ? getLocal('u_bfvas') : 'list',
    screeningEfficiencyView: getLocal('u_se') ? getLocal('u_se') : 'list',
    sourcewiseConversionRateView: getLocal('u_swcr') ? getLocal('u_swcr') : 'list',
    funnelOfJobOpeningStagesView: getLocal('u_fojos') ? getLocal('u_fojos') : 'list',
};

export default function (state = initialState, action) {
    switch (action.type) {
        case 'SOCKET_CONNECTION': {
            return {...state, socketId: action.payload};
        }
        case 'ON_BOARDING_AUTHENTICATE': {
            const data = {isAuthenticated: !!action.payload}
            if (action.payload) {
                data.token = action.payload.token
                data._id = action.payload._id
                data.firstName = action.payload?.firstName || "";
                data.lastName = action.payload?.lastName || ""
                data.email = action.payload.email
                data.S3_BASE_URL = action.payload.S3_BASEURL
                data.fullName = `${action.payload?.firstName} ${action.payload?.lastName}`
                data.orgId = action.payload?.orgId || ""
                data.image = action?.payload?.profileImage || ""
                data.isAdmin = action?.payload?.isAdmin
                data.jobTitle = action?.payload?.jobTitle
                data._user = {
                    label: `${action.payload.firstName} ${action.payload.lastName}`,
                    name: `${action.payload.firstName} ${action.payload.lastName}`,
                    value: action.payload._id ,
                    _id: action.payload._id,
                    profileImage: action?.payload?.profileImage || ""
                }
                data.uac = true;
                data.owner = action.payload?.owner;
                data.preBoardingStatus = action?.payload?.status || null;
                data.preBoardingStep = action?.payload?.steps || null;
                data.preBoardingId = action?.payload?.preBoardingId || null;
                data.settings = {
                    ...(action?.payload?.settings || {}),
                    maxFileSizeLimit: action?.payload?.maxFileSizeLimit ? Number(Number(action?.payload?.maxFileSizeLimit) / 1024 / 1024) : 25
                }
            }
            return {...state, ...data};
        }
        case 'AUTHENTICATE': {
            const data = {isAuthenticated: !!action.payload}
            if (action.payload) {
                data.token = action.payload.token
                data._id = action.payload._id
                data.user_id = action.payload.user_id
                data.firstName = action.payload.firstName
                data.lastName = action.payload.lastName
                data.email = action.payload.email
                data.S3_BASE_URL = action.payload.S3_BASEURL
                data.fullName = `${action.payload.firstName} ${action.payload.lastName}`
                data.orgId = action.payload.orgId
                data.profileImage = action?.payload?.profileImage
                data.isAdmin = action?.payload?.isAdmin
                data.supportModuleEnabled = action?.payload?.supportModuleEnabled === true
                data.jobTitle = action?.payload?.jobTitle
                data.settings = {
                    ...(action?.payload?.settings || {}),
                    maxFileSizeLimit: action?.payload?.settings?.maxFileSizeLimit ? Number(Number(action?.payload?.settings?.maxFileSizeLimit) / 1024 / 1024) : 25
                }
                data.userInfo = {
                    label: `${action.payload.firstName} ${action.payload.lastName}`,
                    name: `${action.payload.firstName} ${action.payload.lastName}`,
                    profileImage: action?.payload?.profileImage,
                    value: action.payload._id,
                    _id: action.payload._id,
                }
                data.planAccess = action.payload.planAccess
                data.isPreBoarding= !!action?.payload?.isPreBoarding
            }
            return {...state, ...data};
        }

        case 'SET_ERROR': {
            return {...state, error: action.payload}
        }
        case 'GET_ATS_MASTER_DATA': {
            if(action?.payload?.uacInfo?.type && typeof action.payload.uacInfo === 'object' && action.payload.uacInfo !== null){
                /** For ATS Module -->> get Data from uacInfo key Not from uac Key will Give Access  Data OF HRMs*/
                action.payload.uacInfo.userType = action?.payload?.uacInfo?.type;
            }
            return {...state, uac: action.payload.uacInfo, phone: action?.payload?.userInfo?.phone || ""}
        }
        case 'UPDATE_MASTER_DATA': {
            const data = {}
            if (action.payload?.userInfo?.contactId === state._id) {
                const info = action.payload?.userInfo
                data.firstName = info.firstName
                data.lastName = info.lastName
                data.fullName = `${info.firstName} ${info.lastName}`
                data.profileImage = info?.profileImage
                data.userInfo = {
                    label: `${info.firstName} ${info.lastName}`,
                    name: `${info.firstName} ${info.lastName}`,
                    profileImage: info?.profileImage,
                    value: info._id,
                    _id: info._id,
                }
            }
            return {...state, ...data,};
        }
        case 'SET_WORKSPACE_LIST': {
            const localState = {};
            if (action.payload?.length) {
                localState.workSpaces = action.payload;
                localState.currentOrg = action.payload.find(e => e.orgId === state.orgId);
            }

            return {...state, ...localState};
        }
        case 'SET_PRODUCT_VIDEO':
            return {...state, videoUrl:action.payload?.recruit};
        case 'SET_SUB_DOMAIN': {
            return {...state, domain : action.payload?.domain};
        }
        case 'SET_LATEST_VERSION': {
            return {...state, version: action.payload.version, release: action.payload};
        }
        case 'SET_FILES': {
            return {...state, files: action.payload};
        }
        case 'SET_UAC_UPDATE':
            return {...state, uacUpdate: action.payload};
        case 'CLOSE_RELEASENOTE_POPUP':
            return {...state, release: {...state.release, displayReleaseNotification: action.payload}};
        case 'CHANGE_JOB_VIEW' : {
            setLocal('u_pv', action.payload);
            return {...state, jobView: action.payload};
        }
        case 'CHANGE_CANDIDATE_VIEW' : {
            setLocal('u_cv', action.payload);
            return {...state, candidateView: action.payload};
        }
        case 'JOB_WISE_CANDIDATE_VIEW' : {
            setLocal('u_jw', action.payload);
            return {...state, jobWiseCandidateView: action.payload};
        }
        case 'RECRUITER_WISE_VIEW' : {
            setLocal('u_rw', action.payload);
            return {...state, recruitWiseView: action.payload};
        }
        case 'STAG_WISE_VIEW' : {
            setLocal('u_sw', action.payload);
            return {...state, stagWiseView: action.payload};
        }
        case 'DISQUALIFY_CANDIDATE_VIEW' : {
            setLocal('u_dv', action.payload);
            return {...state, disqualifyView: action.payload};
        }
        case 'SOURCE_WISE_VIEW' : {
            setLocal('u_swv', action.payload);
            return {...state, sourceWiseView: action.payload};
        }
        case 'ALL_JOB_WISE_VIEW' : {
            setLocal('u_aj', action.payload);
            return {...state, allJobView: action.payload};
        }
        case 'JOB_WISE_INTERVIEW_VIEW' : {
            setLocal('u_jiv', action.payload);
            return {...state, jobInterviewView: action.payload};
        }
        case 'ARCHIVE_JOB_VIEW' : {
            setLocal('u_av', action.payload);
            return {...state, archiveView: action.payload};
        }
        case 'ARCHIVE_CANDIDATE_VIEW' : {
            setLocal('u_cav', action.payload);
            return {...state, candidateArchiveView: action.payload};
        }
        case 'ACTIVE_CANDIDATE_VIEW' : {
            setLocal('u_acv', action.payload);
            return {...state, candidateActiveView: action.payload};
        }
        case 'SET_MULTILEVEL_DATA' : {
            let localState = JSON.parse(JSON.stringify(state));
            let module = MULTILEVEL?.get(action.payload?.type);
            console.log("===== SET_MULTILEVEL_DATA ====",action?.payload)
            if(module){
                localState[module] = action.payload?.data;
                return localState;
            }else return localState;
        }
        case 'TIME_TO_FILL_VIEW' : {
            setLocal('u_ttf', action.payload);
            return {...state, timeToFillView: action.payload};
        }
        case 'EMPLOYEE_TURNOVER_RATE_VIEW' : {
            setLocal('u_etr', action.payload);
            return {...state, employeeTurnoverRateView: action.payload};
        }
        case 'OFFER_ACCEPTANCE_RATE_VIEW' : {
            setLocal('u_oar', action.payload);
            return {...state, offerAcceptanceRateView: action.payload};
        }
        case 'FILL_RATE_VIEW' : {
            setLocal('u_fr', action.payload);
            return {...state, fillRateView: action.payload};
        }
        case 'INTERVIEW_TO_OFFER_RATIO_VIEW' : {
            setLocal('u_itor', action.payload);
            return {...state, interviewToOfferRatioView: action.payload};
        }
        case 'RECRUITMENT_PIPELINE_STATUS_VIEW' : {
            setLocal('u_rps', action.payload);
            return {...state, recruitmentPipelineStatusView: action.payload};
        }
        case 'REJECTED_AND_HOLD_CANDIDATES_VIEW' : {
            setLocal('u_rahc', action.payload);
            return {...state, rejectedAndHoldCandidatesView: action.payload};
        }
        case 'OPENING_VS_APPLICATION_VS_ONBOARDING_VIEW' : {
            setLocal('u_ovavo', action.payload);
            return {...state, openingVsApplicationVsOnboardingView: action.payload};
        }
        case 'OFFER_RELEASED_VS_OFFER_ACCEPTANCE_VIEW' : {
            setLocal('u_orvoa', action.payload);
            return {...state, offerReleasedVsOfferAcceptanceView: action.payload};
        }
        case 'DIVERSITY_HIRING_VIEW' : {
            setLocal('u_dh', action.payload);
            return {...state, diversityHiringView: action.payload};
        }
        case 'JOBWISE_VS_STATUSWISE_VS_TAGWISE_VIEW' : {
            setLocal('u_jwswtw', action.payload);
            return {...state, jobwiseVsStatusWiseVsTagWiseView: action.payload};
        }
        case 'WORKFORCE_FORECAST_VS_ACTUAL_VIEW' : {
            setLocal('u_wfva', action.payload);
            return {...state, workforceForecastVsActualView: action.payload};
        }
        case 'BUDGET_FORECAST_VS_ACTUAL_SPEND_VIEW' : {
            setLocal('u_bfvas', action.payload);
            return {...state, budgetForecastVsActualSpendView: action.payload};
        }
        case 'SCREENING_EFFICIENCY_VIEW' : {
            setLocal('u_se', action.payload);
            return {...state, screeningEfficiencyView: action.payload};
        }
        case 'SOURCE_WISE_CONVERSION_RATE_VIEW' : {
            setLocal('u_swcr', action.payload);
            return {...state, sourcewiseConversionRateView: action.payload};
        }
        case 'FUNNEL_OF_JOB_OPENING_STAGES_VIEW' : {
            setLocal('u_fojos', action.payload);
            return {...state, funnelOfJobOpeningStagesView: action.payload};
        }

        default:
            return state;
    }
}
